module.exports = __webpack_public_path__ + "static/media/carroussel_14.cf200b7b.jpg";